skrilla.directive('franchises',function() {
    return {
        templateUrl: 'directives/franchises/franchises.html',
        scope: {
            sport: "=",
            onClick: "="
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService){
            $scope.key = $scope.sport + "Franchises";
            cacheService.registerObject("contestSport", $scope.sport);
            $scope.franchises = cacheService.getObjectOrElse("franchisesTable", []);

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }

            $scope.reset = function(){
                $scope.query = {
                  sortBy: "name",
                  sortOrder: "ASC",
                  limit: 20
                };
            }
            $scope.reset()

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getFranchises, $scope.key);
            }

            var getFranchises = function() {
                return searchService.get("franchises/" + $scope.sport + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.franchises = response.data.result;
                    cacheService.registerObject("franchisesTable", $scope.franchises);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

        }
    };
});
